import React from 'react';
import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/outline';
import classNames from 'classnames';

interface MobileDisclosureItem {
  name: string;
  onClick: () => void;
  render: () => React.ReactNode;
}

interface MobileDisclosureProps {
  title: string;
  buttonClassName?: string;
  items: MobileDisclosureItem[];
}

function MobileDisclosure({
  title,
  buttonClassName = 'group flex w-full items-center justify-between rounded-lg py-2 md:pr-3.5 md:pl-3 text-base/7 font-medium text-primary-10',
  items,
}: MobileDisclosureProps) {
  return (
    <Disclosure>
      {({ open }) => (
        <>
          <Disclosure.Button className={buttonClassName}>
            <span>{title}</span>
            <ChevronUpIcon
              className={classNames('h-5 w-5 transition-transform', {
                'rotate-180': !open,
              })}
            />
          </Disclosure.Button>
          <Disclosure.Panel className="mt-2 space-y-1">
            {items.map((item, index) => (
              <div key={item.name || index}>{item.render()}</div>
            ))}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

MobileDisclosure.defaultProps = {
  buttonClassName:
    'group flex w-full items-center justify-between rounded-lg py-2 md:pr-3.5 md:pl-3 text-base/7 font-medium text-primary-10',
};

export default MobileDisclosure;
